import { Model, Media } from "@/models";

export default class MediaFile extends Model {
  name!: string;
  file!: Media;
  last_update?: string;
}
